import * as React from "react";
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import NotificationsIcon from '@material-ui/icons/Notifications';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';

import './Notification.scss';
import gql from 'graphql-tag';
import { styles } from './styles';
import { Query } from 'react-apollo';
import { NotificationPopover } from './NotificationPopover';

export const NOTIFICATION_QUERY = gql`
query {
  getNotifications {
    id,message,meta,date_send,date_read,read
  }
}
`;

export interface INotificationQuery {
  id: number,
  message: string,
  date_send: string,
  date_read: string,
  read: boolean,
  meta: string
}

export interface INotificationProps {
  classes?: any,
}

export interface INotification {
  anchorEl?: HTMLElement
}

export const Notification =  withStyles(styles)<INotificationProps>(
  class extends React.Component<INotificationProps & WithStyles<'badgeNotification'>, INotification> {
    constructor(props: INotificationProps & WithStyles<'badgeNotification'>) {
      super(props);
      this.state = {
        anchorEl: undefined,
      };
    }

    public render() {
      const { anchorEl  } = this.state;
      const { classes } = this.props;
      const open = Boolean(anchorEl);

      return (
        <div className="notification-component">
          <Query query={NOTIFICATION_QUERY} pollInterval={20000}>
              {({ loading, error, data, client }) => {
                if (loading || data === undefined) {
                  return <NotificationsIcon />;
                }

                const numberNotifications = data.getNotifications.reduce(
                  (acc:number, item:any):number => acc + (item.read ? 0 : 1) , 0
                );

                return (
                  <div>
                    <IconButton
                      ia-owns={open ? 'simple-popper' : null}
                      color={"inherit"}
                      aria-haspopup={"true"}
                      className={"msg-icon"}
                      onClick={this.handleClick}
                    >
                      {
                        numberNotifications ? (
                        <Badge badgeContent={numberNotifications} classes={{ badge: classes.badgeNotification }} color={"secondary"} >
                          <NotificationsIcon />
                        </Badge>
                        ) : (
                          <NotificationsIcon />
                        )
                      }
                    </IconButton>
                    <NotificationPopover notifications={data.getNotifications} anchorEl={anchorEl} handleClose={this.handleClose} />
                      
                  </div>
                );
              }}
          </Query>
        </div>
      );
    }

    private handleClose = () => {
      this.setState({
        anchorEl: undefined,
      });
    };

    private handleClick = (event: React.MouseEvent<HTMLElement>) => {
      this.setState({ anchorEl: event.currentTarget });
    };
  }
);



// WEBPACK FOOTER //
// ./src/component/shared/layout/notification/Notification.tsx